export const gtag = (...args) => window.gtag?.(...args)
